// The minimum profit `/arbitrages` opens with when its URL names none. Browser-local on purpose:
// it only decides what this operator is shown; the bot detects and records everything regardless.
// [[spec-minimum-profit-ada-filter-on-the-arbitrages-page-url-driven-with-a-local-default]]

export const MIN_PROFIT_STORAGE_KEY = "arb-bot.settings.min-profit-ada";
const DEFAULT_MIN_PROFIT_ADA = 5;

export const isValidMinProfit = (ada: number) => Number.isFinite(ada) && ada >= 0;

export function readDefaultMinProfitAda(): number {
    const stored = Number(localStorage.getItem(MIN_PROFIT_STORAGE_KEY) ?? Number.NaN);
    return isValidMinProfit(stored) ? stored : DEFAULT_MIN_PROFIT_ADA;
}

export function saveDefaultMinProfitAda(ada: number): void {
    localStorage.setItem(MIN_PROFIT_STORAGE_KEY, String(ada));
}
